module.exports = __webpack_public_path__ + "static/media/lds-logo_vi.1865dfde.svg";